'use client'

import { ToolAuthDialog } from '@/components/marketing/tools/tool-auth-dialog'

/** Tool-page auth modal for the Seedance Mini studio. See {@link ToolAuthDialog}. */
export function SeedanceMiniAuthDialog({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  return (
    <ToolAuthDialog
      open={open}
      onOpenChange={onOpenChange}
      description="Create your Soku AI account to generate with Seedance 2.0 Mini. You stay right on this page."
    />
  )
}
